import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer, { drawerClasses } from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { MenuContent } from "./MenuContent";
import { useTenantTranslation } from "hooks/formatters";
import { useUserDisplayName } from "hooks/settings";
import { useSignOut } from "hooks/useSignOut";

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => () => void;
}

export const SideMenuMobile = ({ open, toggleDrawer }: SideMenuMobileProps) => {
  const displayName = useUserDisplayName();
  const signOut = useSignOut();
  const { t } = useTenantTranslation();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      slotProps={{
        backdrop: {
          sx: { top: "var(--app-bar-height, 0px)" },
        },
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: "none",
          backgroundColor: "background.paper",
          top: "var(--app-bar-height, 0px)",
          height: "calc(100% - var(--app-bar-height, 0px))",
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: "70dvw",
          height: "100%",
        }}
      >
        <Stack direction="row" sx={{ p: 2, gap: 1 }}>
          <Typography component="p" variant="h6">
            {displayName}
          </Typography>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={() => void signOut()}
          >
            {t("signOut")}
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};
